/**
 * StatusBadge — solid-fill status indicator.
 * Solid fills, uppercase, tight tracking.
 *
 * Built-in variants: open | closed | short | over | pending | paid | voided |
 *                    partial | active | inactive | draft | approved | info
 * Custom: pass variant="custom" + bg/text props.
 *
 * Usage:
 *   <StatusBadge variant="open" />
 *   <StatusBadge variant="paid" label="Fully Paid" />
 */

const VARIANTS = {
  open:     { bg: '#DCFCE7', text: '#166534' },
  active:   { bg: '#DCFCE7', text: '#166534' },
  paid:     { bg: '#DCFCE7', text: '#166534' },
  approved: { bg: '#DBEAFE', text: '#1E40AF' },
  over:     { bg: '#DBEAFE', text: '#1E40AF' },
  info:     { bg: '#DBEAFE', text: '#1E40AF' },
  pending:  { bg: '#FEF3C7', text: '#92400E' },
  partial:  { bg: '#FEF3C7', text: '#92400E' },
  warning:  { bg: '#FEF3C7', text: '#92400E' },
  short:    { bg: '#FEE2E2', text: '#991B1B' },
  voided:   { bg: '#FEE2E2', text: '#991B1B' },
  danger:   { bg: '#FEE2E2', text: '#991B1B' },
  closed:   { bg: '#F1F5F9', text: '#475569' },
  inactive: { bg: '#F1F5F9', text: '#475569' },
  draft:    { bg: '#F1F5F9', text: '#475569' },
  neutral:  { bg: '#F1F5F9', text: '#475569' },
};

export function StatusBadge({ variant = 'neutral', label }) {
  const v = VARIANTS[variant] || VARIANTS.neutral;
  const displayLabel = label || variant.toUpperCase();

  return (
    <span
      className="inline-flex items-center h-5 px-2 rounded text-[10px] font-semibold tracking-wide uppercase leading-none"
      style={{ backgroundColor: v.bg, color: v.text }}
    >
      {displayLabel}
    </span>
  );
}
